<template>
    <div class="fitbase-schedule" :class="{ 'fitbase-schedule--dark': theme === 'dark' }" :style="widgetColorStyle">
        <div v-if="!settingsLoaded" class="fitbase-schedule__settings-loader">
            <span class="fitbase-loader loader-spin"></span>
        </div>
        <template v-else>

        <!-- Верхняя панель фильтров -->
        <div class="fitbase-schedule__filter-bar">
            <div class="fitbase-schedule__filter-item fitbase-schedule__filter-item--club fitbase-schedule__filter-dd"
                 v-if="clubs.length > 0"
                 :class="{ 'is-open': openDropdown === 'club' }"
                 @click.stop="toggleDropdown('club')">
                <span class="fitbase-schedule__filter-dd-label">{{ getClubLabel(selectedClub) }}</span>
                <svg class="fitbase-schedule__filter-chevron" width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1L6 6L11 1" stroke="#9898A5" stroke-width="1.5" stroke-linecap="round"/></svg>
                <ul class="fitbase-schedule__filter-dd-list" v-if="openDropdown === 'club'" @click.stop>
                    <li v-for="c in clubs" :key="c.value" :class="{ active: c.value == selectedClub }" @click="selectClub(c.value)">{{ c.label }}</li>
                </ul>
            </div>
            <div class="fitbase-schedule__filter-item fitbase-schedule__filter-dd fitbase-schedule__filter-item--desktop-only"
                 :class="{ 'is-active': activeTrainers.length > 0, 'is-open': openDropdown === 'trainer' }"
                 v-if="filters.trainers.length > 0"
                 @click.stop="toggleDropdown('trainer')">
                <span class="fitbase-schedule__filter-dd-label" :class="{ 'is-placeholder': activeTrainers.length === 0 }">
                    {{ activeTrainers.length === 1 ? getTrainerLabel(activeTrainers[0]) : activeTrainers.length > 1 ? 'Тренеры (' + activeTrainers.length + ')' : 'Выберите тренера' }}
                </span>
                <svg class="fitbase-schedule__filter-chevron" width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1L6 6L11 1" stroke="#9898A5" stroke-width="1.5" stroke-linecap="round"/></svg>
                <ul class="fitbase-schedule__filter-dd-list" v-if="openDropdown === 'trainer'" @click.stop>
                    <li v-for="t in filters.trainers" :key="t.value" :class="{ active: activeTrainers.includes(t.value) }" @click="selectTrainer(t.value)">{{ t.label }}</li>
                </ul>
            </div>
            <div class="fitbase-schedule__filter-item fitbase-schedule__filter-dd fitbase-schedule__filter-item--desktop-only"
                 :class="{ 'is-active': activeTemplates.length > 0, 'is-open': openDropdown === 'template' }"
                 v-if="filters.templates.length > 0"
                 @click.stop="toggleDropdown('template')">
                <span class="fitbase-schedule__filter-dd-label" :class="{ 'is-placeholder': activeTemplates.length === 0 }">
                    {{ activeTemplates.length === 1 ? getTemplateLabel(activeTemplates[0]) : activeTemplates.length > 1 ? 'Занятия (' + activeTemplates.length + ')' : 'Выберите занятие' }}
                </span>
                <svg class="fitbase-schedule__filter-chevron" width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1L6 6L11 1" stroke="#9898A5" stroke-width="1.5" stroke-linecap="round"/></svg>
                <ul class="fitbase-schedule__filter-dd-list" v-if="openDropdown === 'template'" @click.stop>
                    <li v-for="t in filters.templates" :key="t.value" :class="{ active: activeTemplates.includes(t.value) }" @click="selectTemplate(t.value)">{{ t.label }}</li>
                </ul>
            </div>
            <div class="fitbase-schedule__filter-item fitbase-schedule__filter-dd fitbase-schedule__filter-item--desktop-only"
                 :class="{ 'is-active': activePlaces.length > 0, 'is-open': openDropdown === 'place' }"
                 v-if="filters.places.length > 0"
                 @click.stop="toggleDropdown('place')">
                <span class="fitbase-schedule__filter-dd-label" :class="{ 'is-placeholder': activePlaces.length === 0 }">
                    {{ activePlaces.length === 1 ? getPlaceLabel(activePlaces[0]) : activePlaces.length > 1 ? 'Залы (' + activePlaces.length + ')' : 'Выберите зал' }}
                </span>
                <svg class="fitbase-schedule__filter-chevron" width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1L6 6L11 1" stroke="#9898A5" stroke-width="1.5" stroke-linecap="round"/></svg>
                <ul class="fitbase-schedule__filter-dd-list" v-if="openDropdown === 'place'" @click.stop>
                    <li v-for="p in filters.places" :key="p.value" :class="{ active: activePlaces.includes(p.value) }" @click="selectPlace(p.value)">{{ p.label }}</li>
                </ul>
            </div>

            <!-- Кнопка входа / профиль — только в виджете -->
            <div v-if="isWidget" class="fitbase-schedule__widget-auth">
                <button v-if="!auth" class="fitbase-schedule__widget-login-btn" @click="showAuthModal = true">
                    <span class="fitbase-schedule__widget-login-icon">
                        <img src="../assets/img/logout-blue.svg" alt="">
                    </span>
                    <span class="fitbase-schedule__widget-login-text">Войти в аккаунт</span>
                </button>
                <div v-else class="fitbase-schedule__widget-profile" @click="showProfileMenu = !showProfileMenu">
                    <span class="fitbase-schedule__widget-profile-name">{{ userName }}</span>
                    <span class="fitbase-schedule__widget-profile-icon">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="32" height="32" rx="10" fill="currentColor"/>
                            <path d="M15.9097 14.9284C16.8615 14.9284 17.6857 14.5871 18.3592 13.9135C19.0326 13.2401 19.374 12.4161 19.374 11.4641C19.374 10.5125 19.0326 9.68838 18.3591 9.01472C17.6855 8.34139 16.8614 8 15.9097 8C14.9577 8 14.1337 8.34139 13.4603 9.01483C12.7868 9.68827 12.4453 10.5124 12.4453 11.4641C12.4453 12.4161 12.7868 13.2402 13.4604 13.9136C14.1339 14.5869 14.958 14.9284 15.9097 14.9284Z" fill="white"/>
                            <path d="M21.9709 19.0601C21.9515 18.7798 21.9122 18.4741 21.8544 18.1512C21.796 17.826 21.7208 17.5185 21.6308 17.2375C21.5379 16.947 21.4115 16.6602 21.2552 16.3853C21.093 16.1 20.9025 15.8515 20.6888 15.6471C20.4652 15.4332 20.1916 15.2613 19.8751 15.1358C19.5597 15.0111 19.2102 14.9479 18.8363 14.9479C18.6895 14.9479 18.5475 15.0081 18.2733 15.1866C18.1045 15.2967 17.9071 15.424 17.6867 15.5648C17.4983 15.6848 17.2431 15.7973 16.9278 15.8992C16.6202 15.9987 16.3079 16.0492 15.9997 16.0492C15.6914 16.0492 15.3792 15.9987 15.0713 15.8992C14.7564 15.7974 14.5011 15.685 14.3129 15.5649C14.0947 15.4254 13.8971 15.2981 13.7258 15.1865C13.4519 15.008 13.3098 14.9478 13.163 14.9478C12.789 14.9478 12.4396 15.0111 12.1244 15.1359C11.8081 15.2612 11.5343 15.4331 11.3106 15.6472C11.0969 15.8518 10.9063 16.1001 10.7443 16.3853C10.5882 16.6602 10.4618 16.9469 10.3687 17.2376C10.2788 17.5186 10.2037 17.826 10.1453 18.1512C10.0875 18.4736 10.0482 18.7795 10.0288 19.0604C10.0097 19.3356 10 19.6213 10 19.9097C10 20.6606 10.2387 21.2684 10.7093 21.7166C11.1742 22.159 11.7892 22.3834 12.5372 22.3834H19.4628C20.2108 22.3834 20.8256 22.1591 21.2906 21.7166C21.7613 21.2687 22 20.6608 22 19.9096C21.9999 19.6198 21.9901 19.334 21.9709 19.0601Z" fill="white"/>
                        </svg>
                    </span>
                    <ul v-if="showProfileMenu" class="fitbase-schedule__widget-profile-dropdown" @click.stop>
                        <li @click="logout">
                            <i><img src="../assets/img/logout.svg" alt=""></i> Выйти из аккаунта
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <auth-modal
            v-if="showAuthModal"
            @close="showAuthModal = false"
            @authenticated="onWidgetAuthSuccess"
            @no_client="onWidgetAuthNoClient"
        />

        <!-- Нижняя панель: пилюли категорий + тоглы + сбросить -->
        <div class="fitbase-schedule__filter-tags" v-if="filters.branches.length > 0 || filters.places.length > 0 || hasActiveFilters || hasMobileFilters">
            <!-- Кнопка настроек (только мобайл) -->
            <button
                v-if="hasMobileFilters"
                class="fitbase-schedule__filter-settings-btn"
                :class="{ 'has-active': hasActiveFilters }"
                @click="openFilterModal"
            >
                <img src="../assets/img/setting.svg" alt="" width="20" height="20">
            </button>
            <div class="fitbase-schedule__filter-tags-scroll-wrapper">
                <button
                    v-if="canScrollTagsLeft"
                    class="fitbase-schedule__filter-scroll-btn fitbase-schedule__filter-scroll-btn--left"
                    @click="scrollTags(-1)"
                ><img src="../assets/img/left.svg" alt=""></button>
                <div class="fitbase-schedule__filter-tags-scroll" ref="tagsScroll" @scroll="updateScrollState">
                    <!-- Десктоп: направления (branches) -->
                    <button
                        v-for="b in filters.branches"
                        :key="'b-' + b.value"
                        class="fitbase-schedule__filter-tag fitbase-schedule__filter-tag--branch"
                        :class="{ active: activeBranches.includes(b.value) }"
                        @click="toggleBranch(b.value)"
                    >{{ b.label }}</button>
                    <!-- Мобайл: залы (places) -->
                    <button
                        v-for="p in mobilePlaces"
                        :key="'p-' + p.value"
                        class="fitbase-schedule__filter-tag fitbase-schedule__filter-tag--place"
                        :class="{ active: activePlaces.includes(p.value) }"
                        @click="togglePlace(p.value)"
                    >{{ p.label }}</button>
                </div>
                <button
                    v-if="canScrollTagsRight"
                    class="fitbase-schedule__filter-scroll-btn fitbase-schedule__filter-scroll-btn--right"
                    @click="scrollTags(1)"
                ><img src="../assets/img/right.svg" alt=""></button>
            </div>
            <div class="fitbase-schedule__filter-toggles">
                <button
                    class="fitbase-schedule__filter-toggle"
                    :class="{ active: filterNeedRegister }"
                    @click="filterNeedRegister = !filterNeedRegister; loadEvents()"
                >
                    <img src="../assets/img/edit.svg" alt="" class="fitbase-schedule__filter-toggle-icon">
                    По записи
                </button>
                <button
                    class="fitbase-schedule__filter-toggle"
                    :class="{ active: filterPaid }"
                    @click="filterPaid = !filterPaid; loadEvents()"
                >
                    <img src="../assets/img/wallet.svg" alt="" class="fitbase-schedule__filter-toggle-icon">
                    Платные
                </button>
                <button v-if="hasActiveFilters" class="fitbase-schedule__filter-reset-all" @click="resetFilters">
                    <span class="fitbase-schedule__filter-toggle-icon fitbase-icon-primary" :style="iconMask(closeIcon)" style="width:12px;height:12px"></span>
                    Сбросить все
                </button>
            </div>
        </div>

        <!-- Навигация по неделям + дни -->
        <div class="fitbase-schedule__calendar">

            <!-- Мобайл: отдельная навигация по неделям -->
            <div class="fitbase-schedule__week-nav">
                <button class="fitbase-schedule__week-btn" :disabled="!canGoPrevWeek" @click="prevWeek">
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M7 1L1 7L7 13" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>
                <span class="fitbase-schedule__week-label">{{ monthYearLabel }}</span>
                <button class="fitbase-schedule__today-btn" @click="goToToday">Сегодня</button>
                <button class="fitbase-schedule__week-btn" :disabled="!canGoNextWeek" @click="nextWeek">
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 1L7 7L1 13" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>
            </div>


            <!-- Десктоп: grid wrapper (flexbox header + css grid body) -->
            <div class="fitbase-schedule__grid-wrapper">
                <!-- Flexbox header bar (seamless gray) -->
                <div class="fitbase-schedule__grid-header-row">
                    <div class="fitbase-schedule__grid-time-corner"></div>
                    <div class="fitbase-schedule__grid-header-days">
                        <button class="fitbase-schedule__grid-nav fitbase-schedule__grid-nav--prev" :disabled="!canGoPrevWeek" @click="prevWeek">
                            <svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M7 1L1 7L7 13" stroke="#555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </button>
                        <div
                            v-for="day in weekDays"
                            :key="'h-' + day.date"
                            class="fitbase-schedule__day-header"
                            :class="{ today: day.isToday }"
                            @click="activeDayDate = day.date"
                        >{{ day.dayLabel }}</div>
                        <button class="fitbase-schedule__grid-nav fitbase-schedule__grid-nav--next" :disabled="!canGoNextWeek" @click="nextWeek">
                            <svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 1L7 7L1 13" stroke="#555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </button>
                    </div>
                </div>

                <div v-if="loading" class="fitbase-schedule__loading">
                    <span class="fitbase-loader loader-spin"></span>
                </div>

                <!-- CSS grid body (one event per cell, explicit placement) -->
                <div v-else class="fitbase-schedule__grid-body">
                    <template v-if="hourGroupsWithLayout.length > 0">
                        <template v-for="group in hourGroupsWithLayout" :key="group.hour">
                            <!-- Time cell spans all slots of this hour group -->
                            <div
                                class="fitbase-schedule__grid-hour"
                                :style="{ gridColumn: '1', gridRow: group.rowStart + ' / span ' + group.maxSlots }"
                            >{{ group.hour }}</div>
                            <!-- One row per slot -->
                            <template v-for="slotIdx in group.maxSlots" :key="group.hour + '-' + slotIdx">
                                <div
                                    class="fitbase-schedule__grid-cell"
                                    v-for="(day, di) in weekDays"
                                    :key="day.date + '-' + group.hour + '-' + slotIdx"
                                    :style="{ gridColumn: di + 2, gridRow: group.rowStart + slotIdx - 1 }"
                                >
                                    <schedule-event-card
                                        v-for="ev in [getEventForDayHourSlot(day.date, group.hour, slotIdx - 1)].filter(Boolean)"
                                        :key="ev.id"
                                        :event="ev"
                                        @click="openEvent(ev)"
                                    />
                                </div>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <div class="fitbase-schedule__grid-hour" style="grid-column: 1; grid-row: 1;"></div>
                        <div class="fitbase-schedule__empty-events">
                            <div class="empty_schedule_calendar_icon">
                                <span class="fitbase-icon-primary" :style="iconMask(calendarIcon)" style="width:20px;height:20px;display:block"></span>
                            </div>
                            <div class="empty_schedule_text">Занятий на эту неделю не найдено</div>
                        </div>
                    </template>
                </div>
            </div>

            <!-- Баннер "Скачай приложение" -->
            <div v-if="hasAppLinks" class="fitbase-schedule__app-banner">
              <div class="fitbase-schedule__app-banner-texts">
                <div class="fitbase-schedule__app-banner-title">Не пропусти занятие — скачай приложение</div>
                <div class="fitbase-schedule__app-banner-subtitle">Записи, абонементы, расписание, тренеры и онлайн-оплата в одном месте</div>
              </div>
              <div class="fitbase-schedule__app-banner-btns">
                <a v-if="appLinks.google_play && osType !== 'ios'" :href="appLinks.google_play" target="_blank">
                  <img :src="isDark ? require('../assets/img/gp-dark.svg') : require('../assets/img/gp-white.svg')" alt="Google Play">
                </a>
                <a v-if="appLinks.apple_store && osType !== 'android'" :href="appLinks.apple_store" target="_blank">
                  <img :src="isDark ? require('../assets/img/appstore-dark.svg') : require('../assets/img/appstore-white.svg')" alt="App Store">
                </a>
                <a v-if="appLinks.rustore && osType !== 'ios'" :href="appLinks.rustore" target="_blank">
                  <img :src="isDark ? require('../assets/img/rustore-dark.svg') : require('../assets/img/rustore-white.svg')" alt="RuStore">
                </a>
              </div>
            </div>

            <!-- Футер "Работает на FITBASE" -->
            <div class="fitbase-schedule__grid-footer-row">
                <a href="https://fitbase.io/?utm_source=widget&utm_campaign=group_schedule" target="_blank" rel="noopener">
                    <span class="fitbase-footer-logo"></span>
                </a>
            </div>

            <!-- Мобайл: табы + список -->
            <div class="fitbase-schedule__mobile">
                <div class="fitbase-schedule__days">
                    <div
                        v-for="day in weekDays"
                        :key="day.date"
                        class="fitbase-schedule__day-tab"
                        :class="{ active: day.date === activeDayDate, today: day.isToday }"
                        @click="activeDayDate = day.date"
                    >
                        <span class="fitbase-schedule__day-name">{{ day.dayName }}</span>
                        <span class="fitbase-schedule__day-num">{{ day.dayNum }}</span>
                    </div>
                </div>

                <div v-if="loading" class="fitbase-schedule__loading">
                    <span class="fitbase-loader loader-spin"></span>
                </div>

                <div v-else class="fitbase-schedule__day-events">
                    <template v-if="activeDayEventsGrouped.length > 0">
                        <div
                            v-for="group in activeDayEventsGrouped"
                            :key="group.hour"
                            class="fitbase-schedule__time-row"
                        >
                            <div class="fitbase-schedule__time-label">{{ group.hour }}</div>
                            <div class="fitbase-schedule__time-events">
                                <schedule-event-card
                                    v-for="event in group.events"
                                    :key="event.id"
                                    :event="event"
                                    @click="openEvent(event)"
                                />
                            </div>
                        </div>
                    </template>
                    <div v-else class="fitbase-schedule__empty">
                      <div class="fitbase-schedule__empty-events">
                        <div class="empty_schedule_calendar_icon">
                          <span class="fitbase-icon-primary" :style="iconMask(calendarIcon)" style="width:20px;height:20px;display:block"></span>
                        </div>
                        <div class="empty_schedule_text">Занятий на этот день не найдено</div>
                      </div>
                    </div>
                </div>
            </div>
        </div>

        <schedule-event-modal
            v-if="showModal"
            :event="selectedEvent"
            :registration-disabled="scheduleSettings.needRegister"
            :theme="theme"
            @close="closeModal"
            @refresh="loadEvents"
        />

        <!-- Модальное окно фильтров (мобайл) -->
        <div v-if="showFilterModal" class="fitbase-schedule__filter-modal-overlay" @click.self="showFilterModal = false">
            <div class="fitbase-schedule__filter-modal">
                <div class="fitbase-schedule__filter-modal-header">
                    <span class="fitbase-schedule__filter-modal-title">Фильтры</span>
                    <button class="fitbase-schedule__filter-modal-close" @click="showFilterModal = false">
                        <span class="fitbase-icon-primary" :style="iconMask(closeIcon)" style="width:16px;height:16px;display:block"></span>
                    </button>
                </div>

                <div class="fitbase-schedule__filter-modal-tabs">
                    <button class="fitbase-schedule__filter-modal-tab" :class="{ active: filterModalTab === 'templates' }" @click="filterModalTab = 'templates'; modalSearch = ''">Занятия</button>
                    <button class="fitbase-schedule__filter-modal-tab" :class="{ active: filterModalTab === 'trainers' }" @click="filterModalTab = 'trainers'; modalSearch = ''">Тренеры</button>
                    <button class="fitbase-schedule__filter-modal-tab" :class="{ active: filterModalTab === 'branches' }" @click="filterModalTab = 'branches'; modalSearch = ''">Направления</button>
                </div>

                <div class="fitbase-schedule__filter-modal-content">
                    <!-- Tab: Занятия -->
                    <template v-if="filterModalTab === 'templates'">
                        <div class="fitbase-schedule__filter-modal-time">
                            <button class="fitbase-schedule__filter-modal-time-btn" :class="{ active: modalFilterTime === 'morning' }" @click="modalFilterTime = modalFilterTime === 'morning' ? null : 'morning'">
                                <span class="fitbase-schedule__filter-modal-time-title">Утро</span>
                                <span v-if="timePeriods[1]" class="fitbase-schedule__filter-modal-time-range">{{ timePeriods[1] }}</span>
                            </button>
                            <button class="fitbase-schedule__filter-modal-time-btn" :class="{ active: modalFilterTime === 'day' }" @click="modalFilterTime = modalFilterTime === 'day' ? null : 'day'">
                                <span class="fitbase-schedule__filter-modal-time-title">День</span>
                                <span v-if="timePeriods[2]" class="fitbase-schedule__filter-modal-time-range">{{ timePeriods[2] }}</span>
                            </button>
                            <button class="fitbase-schedule__filter-modal-time-btn" :class="{ active: modalFilterTime === 'evening' }" @click="modalFilterTime = modalFilterTime === 'evening' ? null : 'evening'">
                                <span class="fitbase-schedule__filter-modal-time-title">Вечер</span>
                                <span v-if="timePeriods[3]" class="fitbase-schedule__filter-modal-time-range">{{ timePeriods[3] }}</span>
                            </button>
                        </div>
                        <div class="fitbase-schedule__filter-modal-audience">
                            <button class="fitbase-schedule__filter-modal-audience-btn" :class="{ active: modalFilterAudience === 'adult' }" @click="modalFilterAudience = modalFilterAudience === 'adult' ? null : 'adult'">Взрослые</button>
                            <button class="fitbase-schedule__filter-modal-audience-btn" :class="{ active: modalFilterAudience === 'kids' }" @click="modalFilterAudience = modalFilterAudience === 'kids' ? null : 'kids'">Дети</button>
                        </div>
                        <div class="fitbase-schedule__filter-modal-search">
                            <img :src="searchIcon" alt="" class="fitbase-schedule__filter-modal-search-icon" width="16" height="16">
                            <input type="text" placeholder="Поиск..." v-model="modalSearch" class="fitbase-schedule__filter-modal-search-input">
                        </div>
                        <div class="fitbase-schedule__filter-modal-list">
                            <div v-for="t in filteredModalTemplates" :key="t.value" class="fitbase-schedule__filter-modal-item" @click="toggleModalTemplate(t.value)">
                                <span class="fitbase-schedule__filter-modal-item-label">{{ t.label }}</span>
                                <span class="fitbase-schedule__filter-modal-checkbox" :class="{ checked: modalTemplates.includes(t.value) }">
                                    <img v-if="modalTemplates.includes(t.value)" :src="checkmarkIcon" alt="" width="14">
                                </span>
                            </div>
                        </div>
                    </template>

                    <!-- Tab: Тренеры -->
                    <template v-if="filterModalTab === 'trainers'">
                        <div class="fitbase-schedule__filter-modal-search">
                            <img :src="searchIcon" alt="" class="fitbase-schedule__filter-modal-search-icon" width="16" height="16">
                            <input type="text" placeholder="Поиск..." v-model="modalSearch" class="fitbase-schedule__filter-modal-search-input">
                        </div>
                        <div class="fitbase-schedule__filter-modal-list">
                            <div v-for="t in filteredModalTrainers" :key="t.value" class="fitbase-schedule__filter-modal-item" @click="toggleModalTrainer(t.value)">
                                <span class="fitbase-schedule__filter-modal-item-avatar">
                                    <img v-if="t.photo" :src="t.photo" :alt="t.label" class="fitbase-schedule__filter-modal-item-avatar-img">
                                    <span v-else class="fitbase-schedule__filter-modal-item-avatar-empty">
                                        <img src="../assets/img/profile.svg" alt="" width="16" height="16">
                                    </span>
                                </span>
                                <span class="fitbase-schedule__filter-modal-item-label">{{ t.label }}</span>
                                <span class="fitbase-schedule__filter-modal-checkbox" :class="{ checked: modalTrainers.includes(t.value) }">
                                    <img v-if="modalTrainers.includes(t.value)" :src="checkmarkIcon" alt="" width="14">
                                </span>
                            </div>
                        </div>
                    </template>

                    <!-- Tab: Направления -->
                    <template v-if="filterModalTab === 'branches'">
                        <div class="fitbase-schedule__filter-modal-search">
                            <img :src="searchIcon" alt="" class="fitbase-schedule__filter-modal-search-icon" width="16" height="16">
                            <input type="text" placeholder="Поиск..." v-model="modalSearch" class="fitbase-schedule__filter-modal-search-input">
                        </div>
                        <div class="fitbase-schedule__filter-modal-list">
                            <div v-for="b in filteredModalBranches" :key="b.value" class="fitbase-schedule__filter-modal-item" @click="toggleModalBranch(b.value)">
                                <span class="fitbase-schedule__filter-modal-item-label">{{ b.label }}</span>
                                <span class="fitbase-schedule__filter-modal-checkbox" :class="{ checked: modalBranches.includes(b.value) }">
                                    <img v-if="modalBranches.includes(b.value)" :src="checkmarkIcon" alt="" width="14">
                                </span>
                            </div>
                        </div>
                    </template>
                </div>

                <div class="fitbase-schedule__filter-modal-footer">
                    <button class="fitbase-schedule__filter-modal-reset" @click="resetModalFilters">Сбросить</button>
                    <button class="fitbase-schedule__filter-modal-apply" @click="applyFilters">Применить</button>
                </div>
            </div>
        </div>
        </template>
    </div>
</template>

<script>
import moment from 'moment'
import ScheduleEventCard from '../components/ScheduleEventCard'
import ScheduleEventModal from '../components/ScheduleEventModal'
import AuthModal from '../components/AuthModal.vue'
import closeIcon from '../assets/img/close.svg'
import calendarIcon from '../assets/img/calendar-blue.svg'
import searchIcon from '../assets/img/search.svg'
import checkmarkIcon from '../assets/img/checkmark.svg'
import { useToast } from 'vue-toastification'
import { handlePendingPaymentReturn } from '../utilities/paymentReturn'

export default {
    name: 'Schedule',
    components: { ScheduleEventCard, ScheduleEventModal, AuthModal },
    setup() {
        return { toast: useToast() }
    },
    props: {
        isWidget: {
            type: Boolean,
            default: false,
        },
        theme: {
            type: String,
            default: 'light',
        },
        widgetClub: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            closeIcon,
            calendarIcon,
            searchIcon,
            checkmarkIcon,
            weekStart: moment().startOf('isoWeek'),
            activeDayDate: moment().format('YYYY-MM-DD'),
            events: [],
            clubs: [],
            selectedClub: null,
            filters: { trainers: [], templates: [], places: [], branches: [] },
            activeTrainers: [],
            activeTemplates: [],
            activeBranches: [],
            activePlaces: [],
            filterNeedRegister: false,
            filterPaid: false,
            loading: false,
            showModal: false,
            selectedEvent: null,
            showAuthModal: false,
            showProfileMenu: false,
            openDropdown: null,
            showFilterModal: false,
            filterModalTab: 'templates',
            modalSearch: '',
            filterTime: null,
            filterAudience: null,
            widgetColor: null,
            settingsLoaded: false,
            modalTrainers: [],
            modalTemplates: [],
            modalPlaces: [],
            modalBranches: [],
            modalFilterTime: null,
            modalFilterAudience: null,
            canScrollTagsLeft: false,
            canScrollTagsRight: false,
            scheduleSettings: { countWeek: 0, needRegister: false },
            timePeriods: { 1: '', 2: '', 3: '' },
        }
    },
    computed: {
        isDark() {
            return this.theme === 'dark'
        },
        widgetColorStyle() {
            if (!this.widgetColor) return {}
            return {
                '--fb-primary': this.widgetColor,
                '--fb-primary-muted': this.widgetColor + '1A',
            }
        },
        appLinks() {
            return this.$store.getters.storeLinks || {}
        },
        hasAppLinks() {
            const l = this.appLinks
            return !!(l.google_play || l.apple_store || l.rustore)
        },
        osType() {
            const ua = navigator.userAgent
            if (/android/i.test(ua)) return 'android'
            if (/ipad|iphone|ipod/i.test(ua)) return 'ios'
            // iPadOS 13+ маскируется под Mac, но имеет тач
            if (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios'
            return 'other'
        },
        weekDays() {
            return Array.from({ length: 7 }, (_, i) => {
                const day = this.weekStart.clone().add(i, 'days')
                const label = day.format('dd, D MMMM')
                return {
                    date: day.format('YYYY-MM-DD'),
                    dayName: day.format('dd'),
                    dayNum: day.format('DD'),
                    dayFull: day.format('D MMMM'),
                    dayLabel: label.charAt(0).toUpperCase() + label.slice(1),
                    isToday: day.isSame(moment(), 'day'),
                }
            })
        },
        weekLabel() {
            const start = this.weekStart
            const end = start.clone().add(6, 'days')
            if (start.month() === end.month()) {
                return `${start.format('D')} – ${end.format('D MMMM')}`
            }
            return `${start.format('D MMM')} – ${end.format('D MMM')}`
        },
        monthYearLabel() {
            const mid = this.weekStart.clone().add(3, 'days')
            const label = mid.format('MMMM YYYY')
            return label.charAt(0).toUpperCase() + label.slice(1)
        },
        activeDayEvents() {
            return this.getEventsForDay(this.activeDayDate)
        },
        hourSlots() {
            if (!this.events.length) return []
            const hours = new Set()
            for (const event of this.events) {
                if (!event.time_start) continue
                hours.add(parseInt(event.time_start.slice(0, 2)))
            }
            return Array.from(hours)
                .sort((a, b) => a - b)
                .map(h => String(h).padStart(2, '0') + ':00')
        },
        hourGroups() {
            return this.hourSlots.map(hour => {
                let maxSlots = 0
                for (const day of this.weekDays) {
                    const cnt = this.getEventsForDayHour(day.date, hour).length
                    if (cnt > maxSlots) maxSlots = cnt
                }
                return { hour, maxSlots: Math.max(maxSlots, 1) }
            })
        },
        hourGroupsWithLayout() {
            let currentRow = 1
            return this.hourGroups.map(group => {
                const rowStart = currentRow
                currentRow += group.maxSlots
                return { ...group, rowStart }
            })
        },
        activeDayEventsGrouped() {
            const groups = []
            const hourMap = {}
            for (const event of this.activeDayEvents) {
                const hourKey = event.time_start ? event.time_start.slice(0, 2) + ':00' : '00:00'
                if (!hourMap[hourKey]) {
                    hourMap[hourKey] = { hour: hourKey, events: [] }
                    groups.push(hourMap[hourKey])
                }
                hourMap[hourKey].events.push(event)
            }
            return groups
        },
        clubIdFromRoute() {
            return this.widgetClub || this.$route.query.club || null
        },
        userCurrentClub() {
            return this.$store.state.user && this.$store.state.user.current_club || null
        },
        hasActiveFilters() {
            return !!(this.activeTrainers.length || this.activeTemplates.length || this.activeBranches.length || this.activePlaces.length || this.filterNeedRegister || this.filterPaid || this.filterTime || this.filterAudience)
        },
        hasMobileFilters() {
            return this.filters.trainers.length > 0 || this.filters.templates.length > 0 || this.filters.branches.length > 0
        },
        filteredModalTrainers() {
            const base = this.filters.trainers.filter(t => t.value != 0)
            if (!this.modalSearch) return base
            const q = this.modalSearch.toLowerCase()
            return base.filter(t => t.label.toLowerCase().includes(q))
        },
        filteredModalTemplates() {
            const base = this.filters.templates.filter(t => t.value != 0)
            if (!this.modalSearch) return base
            const q = this.modalSearch.toLowerCase()
            return base.filter(t => t.label.toLowerCase().includes(q))
        },
        filteredModalPlaces() {
            const base = this.filters.places.filter(p => p.value != 0)
            if (!this.modalSearch) return base
            const q = this.modalSearch.toLowerCase()
            return base.filter(p => p.label.toLowerCase().includes(q))
        },
        filteredModalBranches() {
            const base = this.filters.branches.filter(b => b.value != 0)
            if (!this.modalSearch) return base
            const q = this.modalSearch.toLowerCase()
            return base.filter(b => b.label.toLowerCase().includes(q))
        },
        mobilePlaces() {
            return this.filters.places.filter(p => p.value != 0)
        },
        canGoPrevWeek() {
            return this.weekStart.isAfter(moment().startOf('isoWeek'))
        },
        canGoNextWeek() {
            const count = this.scheduleSettings.countWeek
            if (!count) return true
            return this.weekStart.isBefore(moment().startOf('isoWeek').add(count - 1, 'weeks'))
        },
        auth() {
            return !!this.$store.state.token
        },
        userName() {
            return this.$store.getters.userName
        },
    },
    watch: {
        '$store.state.token'() {
            this.loadEvents()
        },
        hasActiveFilters(val, oldVal) {
            const el = this.$refs.tagsScroll
            let isLastTagSelected = false
            if (val && !oldVal && el) {
                const lastBranchEl = [...el.querySelectorAll('.fitbase-schedule__filter-tag--branch')].pop()
                const lastPlaceEl = [...el.querySelectorAll('.fitbase-schedule__filter-tag--place')].pop()
                const lastBranch = this.filters.branches[this.filters.branches.length - 1]
                const lastPlace = this.mobilePlaces[this.mobilePlaces.length - 1]
                isLastTagSelected =
                    (lastBranchEl && lastBranch && this.activeBranches.includes(lastBranch.value)) ||
                    (lastPlaceEl && lastPlace && this.activePlaces.includes(lastPlace.value))
            }
            this.$nextTick(() => {
                if (!el) return
                if (isLastTagSelected) el.scrollLeft = el.scrollWidth
                this.updateScrollState()
            })
        },
    },
    methods: {
        getEventsForDay(date) {
            return this.events.filter(e => e.date === date)
        },
        getEventsForDayHour(date, hour) {
            const h = parseInt(hour)
            return this.events.filter(e =>
                e.date === date &&
                e.time_start &&
                parseInt(e.time_start.slice(0, 2)) === h
            )
        },
        getEventForDayHourSlot(date, hour, slotIndex) {
            return this.getEventsForDayHour(date, hour)[slotIndex] || null
        },
        prevWeek() {
            if (!this.canGoPrevWeek) return
            this.weekStart = this.weekStart.clone().subtract(1, 'week')
            const firstDay = this.weekDays[0].date
            this.activeDayDate = firstDay
            this.loadEvents()
        },
        nextWeek() {
            if (!this.canGoNextWeek) return
            this.weekStart = this.weekStart.clone().add(1, 'week')
            const firstDay = this.weekDays[0].date
            this.activeDayDate = firstDay
            this.loadEvents()
        },
        getClubId() {
            // Приоритет: выбранный клуб → URL ?club= → current_club из профиля → 1
            return this.selectedClub || this.clubIdFromRoute || this.userCurrentClub || 1
        },
        async loadClubs() {
            try {
                const response = await this.$api.schedule.getScheduleClubs()
                this.clubs = Array.isArray(response.data) ? response.data : []
                if (this.clubs.length > 0) {
                    const preferred = this.clubIdFromRoute || this.userCurrentClub
                    const found = preferred && this.clubs.find(c => String(c.value) === String(preferred))
                    this.selectedClub = found ? found.value : this.clubs[0].value
                    this._updateClubUrl(this.selectedClub)
                    this.loadClubDocuments()
                }
            } catch (e) {
                console.error(e)
            }
        },
        async loadEvents() {
            this.loading = true
            try {
                const params = {
                    params: {
                        dateFrom: this.weekDays[0].date,
                        dateTo: this.weekDays[6].date,
                        all: 1,
                        'filial[]': this.getClubId(),
                    }
                }
                if (this.activeTrainers.length) params.params['trainer'] = this.activeTrainers
                if (this.activeTemplates.length) params.params['training'] = this.activeTemplates
                if (this.activeBranches.length) params.params['subdivision'] = this.activeBranches
                if (this.activePlaces.length) params.params['places'] = this.activePlaces
                if (this.filterNeedRegister) params.params['registration'] = 1
                if (this.filterPaid) params.params['pay'] = 1
                if (this.filterTime === 'morning') params.params['period[]'] = 1
                else if (this.filterTime === 'day') params.params['period[]'] = 2
                else if (this.filterTime === 'evening') params.params['period[]'] = 3
                if (this.filterAudience) params.params['ageType'] = this.filterAudience

                const response = await this.$api.schedule.getScheduleList(params)
                this.events = Array.isArray(response.data) ? response.data : []
            } catch (e) {
                console.error(e)
                this.events = []
            } finally {
                this.loading = false
            }
        },
        async loadFilters() {
            try {
                const params = {
                    params: {
                        viewName: 'week',
                        dateStart: this.weekDays[0].date,
                        clubId: this.getClubId(),
                    }
                }
                const response = await this.$api.schedule.getScheduleFilters(params)
                const data = response.data || {}
                this.filters.trainers = data.trainers || []
                this.filters.templates = data.scheduleTemplates || []
                this.filters.places = data.places || []
                this.filters.branches = data.branches || []
                this.$nextTick(() => this.updateScrollState())
            } catch (e) {
                console.error(e)
            }
        },
        toggleBranch(id) {
            const idx = this.activeBranches.indexOf(id)
            if (idx === -1) this.activeBranches.push(id)
            else this.activeBranches.splice(idx, 1)
            this.loadEvents()
        },
        onClubChange() {
            this.activeTrainers = []
            this.activeTemplates = []
            this.activeBranches = []
            this.activePlaces = []
            this.filterNeedRegister = false
            this.filterPaid = false
            this.filterTime = null
            this.filterAudience = null
            this._updateClubUrl(this.selectedClub)
            this.loadClubDocuments()
            this.loadFilters()
            this.loadEvents()
            this.loadScheduleSettings()
        },
        loadClubDocuments() {
            this.$store.dispatch('loadClubDocuments', this.selectedClub)
        },
        _updateClubUrl(clubId) {
            if (this.isWidget) return
            const url = new URL(window.location.href)
            url.searchParams.set('club', clubId)
            history.replaceState(null, '', url.toString())
        },
        iconMask(src) {
            return { maskImage: `url(${src})`, webkitMaskImage: `url(${src})` }
        },
        toggleDropdown(name) {
            this.openDropdown = this.openDropdown === name ? null : name
        },
        getClubLabel(value) {
            const c = this.clubs.find(c => c.value == value)
            return c ? c.label : ''
        },
        getTrainerLabel(value) {
            const t = this.filters.trainers.find(t => t.value == value)
            return t ? t.label : ''
        },
        getTemplateLabel(value) {
            const t = this.filters.templates.find(t => t.value == value)
            return t ? t.label : ''
        },
        getPlaceLabel(value) {
            const p = this.filters.places.find(p => p.value == value)
            return p ? p.label : ''
        },
        selectClub(value) {
            this.selectedClub = value
            this.openDropdown = null
            this.onClubChange()
        },
        selectTrainer(value) {
            this.activeTrainers = value ? [value] : []
            this.openDropdown = null
            this.loadEvents()
        },
        selectTemplate(value) {
            this.activeTemplates = value ? [value] : []
            this.openDropdown = null
            this.loadEvents()
        },
        selectPlace(value) {
            this.activePlaces = value ? [value] : []
            this.openDropdown = null
            this.loadEvents()
        },
        resetFilters() {
            this.activeTrainers = []
            this.activeTemplates = []
            this.activeBranches = []
            this.activePlaces = []
            this.filterNeedRegister = false
            this.filterPaid = false
            this.filterTime = null
            this.filterAudience = null
            this.openDropdown = null
            this.loadEvents()
        },
        openFilterModal() {
            this.modalTrainers = [...this.activeTrainers]
            this.modalTemplates = [...this.activeTemplates]
            this.modalBranches = [...this.activeBranches]
            this.modalFilterTime = this.filterTime
            this.modalFilterAudience = this.filterAudience
            this.modalSearch = ''
            this.filterModalTab = 'templates'
            this.showFilterModal = true
        },
        applyFilters() {
            this.activeTrainers = [...this.modalTrainers]
            this.activeTemplates = [...this.modalTemplates]
            this.activeBranches = [...this.modalBranches]
            this.filterTime = this.modalFilterTime
            this.filterAudience = this.modalFilterAudience
            this.showFilterModal = false
            this.loadEvents()
        },
        resetModalFilters() {
            this.modalTrainers = []
            this.modalTemplates = []
            this.modalBranches = []
            this.modalFilterTime = null
            this.modalFilterAudience = null
            this.activePlaces = []
            this.filterNeedRegister = false
            this.filterPaid = false
            this.applyFilters()
        },
        toggleModalTrainer(value) {
            const idx = this.modalTrainers.indexOf(value)
            if (idx === -1) this.modalTrainers.push(value)
            else this.modalTrainers.splice(idx, 1)
        },
        toggleModalTemplate(value) {
            const idx = this.modalTemplates.indexOf(value)
            if (idx === -1) this.modalTemplates.push(value)
            else this.modalTemplates.splice(idx, 1)
        },
        toggleModalPlace(value) {
            const idx = this.modalPlaces.indexOf(value)
            if (idx === -1) this.modalPlaces.push(value)
            else this.modalPlaces.splice(idx, 1)
        },
        toggleModalBranch(value) {
            const idx = this.modalBranches.indexOf(value)
            if (idx === -1) this.modalBranches.push(value)
            else this.modalBranches.splice(idx, 1)
        },
        togglePlace(id) {
            const idx = this.activePlaces.indexOf(id)
            if (idx === -1) this.activePlaces.push(id)
            else this.activePlaces.splice(idx, 1)
            this.loadEvents()
        },
        scrollTags(direction) {
            const el = this.$refs.tagsScroll
            if (el) el.scrollBy({ left: direction * 200, behavior: 'smooth' })
        },
        updateScrollState() {
            const el = this.$refs.tagsScroll
            if (!el) return
            this.canScrollTagsLeft = el.scrollLeft > 0
            this.canScrollTagsRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1
        },
        openEvent(event) {
            if (this.isEventPast(event)) return
            this.selectedEvent = event
            this.showModal = true
            if (!this.isWidget) {
                const url = new URL(window.location.href)
                url.searchParams.set('event', event.id)
                history.replaceState(null, '', url.toString())
            }
        },
        openEventById(id) {
            this.selectedEvent = { id }
            this.showModal = true
        },
        isEventPast(event) {
            const today = moment().format('YYYY-MM-DD')
            if (event.date < today) return true
            if (event.date === today && event.time_end && event.time_end !== '00:00:00') {
                return moment().format('HH:mm:ss') > event.time_end
            }
            return false
        },
        async loadScheduleSettings() {
            try {
                const response = await this.$api.settings.settings({ c: this.getClubId() })
                const widget = response.data?.widget || {}
                this.scheduleSettings = {
                    countWeek: parseInt(widget.countWeek ?? 0) || 0,
                    needRegister: !!widget.isNeedRegisterBySchedule,
                }
                if (widget.primaryWidgetColor) {
                    this.widgetColor = widget.primaryWidgetColor
                }
                const times = response.data?.times || {}
                this.timePeriods = {
                    1: times[1] ? times[1].replace('-', ' – ') : '',
                    2: times[2] ? times[2].replace('-', ' – ') : '',
                    3: times[3] ? times[3].replace('-', ' – ') : '',
                }
            } catch (e) {
                console.error(e)
            } finally {
                this.settingsLoaded = true
            }
        },
        goToToday() {
            const today = moment()
            this.weekStart = today.clone().startOf('isoWeek')
            this.activeDayDate = today.format('YYYY-MM-DD')
            this.loadEvents()
        },
        closeModal() {
            this.showModal = false
            this.selectedEvent = null
            if (!this.isWidget) {
                const url = new URL(window.location.href)
                url.searchParams.delete('event')
                history.replaceState(null, '', url.toString())
            }
        },
        onWidgetAuthSuccess() {
            this.showAuthModal = false
            this.$store.dispatch('loadUser')
            this.loadEvents()
        },
        async onWidgetAuthNoClient({ phone, token }) {
            if (token) {
                localStorage.setItem('fitbase_token', token)
            }

            try {
                await this.$api.auth.registration({
                    name: 'без данных',
                    surname: 'Клиент',
                    patronymic: '',
                    b_day: '',
                    phone: phone,
                    club: this.getClubId(),
                })
            } catch (e) { /* silent */ }
            if (token) {
                this.$store.commit('SET_TOKEN', token)
            }
            this.$store.dispatch('loadUser')
            this.loadEvents()
        },
        logout() {
            localStorage.removeItem('fitbase_token')
            this.$store.commit('SET_TOKEN', null)
            this.showProfileMenu = false
        },
        async showPendingPaymentResult() {
            const result = await handlePendingPaymentReturn(this.$api, this.$store)

            if (!result) {
                return
            }

            if (!result.paid) {
                this.toast.error(result.message)
                return
            }

            if (result.message) {
                this.toast.success(result.message)
            }
            this.loadEvents()
        },
    },
    mounted() {
        this._onResize = () => this.updateScrollState()
        window.addEventListener('resize', this._onResize)
        this._onClickOutside = () => { this.openDropdown = null }
        document.addEventListener('click', this._onClickOutside)
    },
    beforeUnmount() {
        this.$store.dispatch('resetClubDocuments')
        window.removeEventListener('resize', this._onResize)
        document.removeEventListener('click', this._onClickOutside)
    },
    async created() {
        if (this.isWidget && this.$store.state.token) {
            this.$store.dispatch('loadUser')
        }
        await this.loadClubs()
        await this.loadScheduleSettings()
        this.loadEvents()
        this.loadFilters()
        const eventId = new URLSearchParams(window.location.search).get('event')
        if (eventId) {
            this.openEventById(parseInt(eventId))
        }
        if (this.isWidget) {
            this.showPendingPaymentResult()
        }
    },
}
</script>
